// SDK events

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
interface SDKEventType extends Function {
  type: string
}

export class SDKEvent extends Event {
  static type: string

  constructor(type: string, options?: EventInit) {
    super(type, options);
    (this.constructor as SDKEventType).type = type
  }

  toString(): string {
    return this.type || (this.constructor as SDKEventType).type as string
  }
}

export class SDKCustomEvent<T> extends CustomEvent<T> {
  static type: string

  constructor(type: string, options?: CustomEventInit | undefined) {
    super(type, options);
    (this.constructor as SDKEventType).type = type
  }

  toString(): string {
    return this.type || (this.constructor as SDKEventType).type as string
  }
}

export type PlaybackCustomEvent = {
  time: number,
  ranges?: TimeRanges,
  counter?: number,
  duration: number,
  progress: number
}
